import Symbol           from 'es6-symbol/polyfill';
import EventEmitter     from 'events';
import axios            from 'axios';

let singleton = Symbol();
let singletonEnforcer = Symbol();

class OrdersService extends EventEmitter {

  //________________________________________________________ constructor
  // -
  constructor(pEnforcer) {
    if (pEnforcer !== singletonEnforcer) {
      throw 'Cannot construct singleton';
    }
    super();
    this._cart = null;
  }

  static getInstance() {
    if (!this[singleton]) {
      this[singleton] = new OrdersService(singletonEnforcer);
    }
    return this[singleton];
  }


  get cart() {
    return this._cart;
  }

  getProcessings() {
    const seq = axios.get('/api/v2/processings');
    seq.catch( console.error );
    return seq;
  }

  getById(id) {
    return axios.get(`/api/v2/orders/${id}`).then( res => {
      this._cart = this._parse(res.data);
      const event = new CustomEvent('cart:update', { detail: res.data.items.length });
      document.body.dispatchEvent(event);
      this.emit('updated', res.data);
    })
  }

  get() {
    return new Promise( (resolve, reject) => {
      this.emit('updating');
      if(this._cart && this._cart.items.length === 0) this.emit('updated', null);
      axios.get('/api/v2/orders/me').then( res => {
        this._cart = this._parse(res.data);
        resolve(res.data);
        const event = new CustomEvent('cart:update', { detail: res.data.items.length });
        document.body.dispatchEvent(event);
        this.emit('updated', res.data);
      }).catch( (err) => {
        this._cart = {};
        this.emit('updated', {});
        console.error(err);
        reject(err);
      });
    })
  }

  promoUpdate(code = null) {
    return new Promise( (resolve, reject) => {
      this.emit('updating');
      const seq = axios.patch(`/api/v2/orders/${this._cart.id}/promotions/apply`, {couponCode: code}, { headers: {
        'Content-Type': 'application/merge-patch+json'
      }});
      seq.then( (res) => {
        this.get().then(() => {
          resolve(res);
        }).catch(reject);
      }).catch( (err) => {
        console.error(err);
        reject(err);
      });
    });
  }

  // What the customer is being shown: the server refuses to check/complete the payment if the
  // cart no longer matches it (processing type closed or swapped, cart edited in another tab...)
  expected(cart = this._cart) {
    return {
      expectedTotal: cart ? cart.totalTtc : null,
      expectedProcessingType: cart && cart.processingType ? cart.processingType['@id'] : null
    };
  }

  // Displayed by CartResume, which stays mounted across all the cart steps
  notifyCartChanged(message = null) {
    this.emit('cart-changed', message || window.Translator.trans('front.cart.payment.cart_changed'));
  }

  confirm(expected = {}) {
    return new Promise( (resolve, reject) => {
      axios.patch(`/api/v2/orders/${this._cart.id}/complete`, {...expected}, {
        headers: {
          'Content-Type': 'application/merge-patch+json'
        }
      }).then( res => {
        this._cart = this._parse(res.data);
        resolve(res);
      }).catch(reject);
    });
  }

  getShippings() {
    const seq = axios.get(`/api/v2/orders/${this._cart.id}/shippings`);
    seq.catch( console.error );
    return seq;
  }

  update(params = {}) {
    const seq = axios.patch(`/api/v2/orders/${this._cart.id}`, {...params}, { headers: {
      'Content-Type': 'application/merge-patch+json'
    }});
    this.emit('updating');
    seq.then( res => {
      this._cart = this._parse(res.data);
      const event = new CustomEvent('cart:update', { detail: res.data.items.length });
      document.body.dispatchEvent(event);
      this.emit('updated', res.data);
    }).catch( console.error );
    return seq;
  }

  addItem(datas) {
    const seq = axios.post('/api/v2/orders/items', {...datas});
    seq.catch( console.error );
    return seq;
  }

  addGroupedItem( datas ) {
    return axios.post('/api/v2/orders/items/bulk', {...datas});
  }

  updateItem(id, datas) {
    const seq = axios.patch(`/api/v2/orders/${this._cart.id}/items/${id}`, {...datas}, { headers: {
      'Content-Type': 'application/merge-patch+json'
    }});
    seq.catch( console.error );
    return seq;
  }

  deleteItem(id) {
    const seq = axios.delete(`/api/v2/orders/items/${id}`);
    seq.catch( console.error );
    return seq;
  }

  _parse( datas ) {
    if(!datas.items) return datas;
    const options = datas.items.filter( item => item.parentItem);
    for( let i = datas.items.length - 1; i >= 0 ; i--) {
      const item = datas.items[i];
      item.options = options.filter(option => option.parentItem.id === item.id );
      if(item.parentItem) datas.items.splice(i, 1);
    }
    return datas;
  }
}
export default OrdersService.getInstance();
